import parse from 'html-react-parser';
import Image from 'next/image';
import type React from 'react';
import { type GalleryProps, ItemText, ItemTitle, ItemWrapper, SectionBody } from './Shared';

export const DesktopItemsGallery: React.FC<GalleryProps> = ({ items }) => {
  return (
    <SectionBody pt={70} justifyContent="space-between">
      <ItemWrapper flexDirection="column" alignItems="center">
        <Image src={items.left.image} alt={items.left.title} style={{ pointerEvents: 'none' }} />
        <ItemTitle>{parse(items.left.title)}</ItemTitle>
        <ItemText>{parse(items.left.subtitle)}</ItemText>
      </ItemWrapper>
      <ItemWrapper flexDirection="column" alignItems="center">
        <Image src={items.center.image} alt={items.center.title} style={{ pointerEvents: 'none' }} />
        <ItemTitle>{parse(items.center.title)}</ItemTitle>
        <ItemText>{parse(items.center.subtitle)}</ItemText>
      </ItemWrapper>
      <ItemWrapper flexDirection="column" alignItems="center">
        <Image src={items.right.image} alt={items.right.title} style={{ pointerEvents: 'none' }} />
        <ItemTitle>{parse(items.right.title)}</ItemTitle>
        <ItemText>{parse(items.right.subtitle)}</ItemText>
      </ItemWrapper>
    </SectionBody>
  );
};
